module.exports = __webpack_public_path__ + "img/stock5.a3eb32f4.png";